export var HighLowEventType;
(function (HighLowEventType) {
    HighLowEventType["lowerHighsBreakout"] = "lowerHighsBreakout";
    HighLowEventType["higherLowsBreakdown"] = "higherLowsBreakdown";
})(HighLowEventType || (HighLowEventType = {}));
//# sourceMappingURL=HighLow.js.map